module.exports = __webpack_public_path__ + "494cd07c/img/share-icon.0f8a11b4.svg";